export default "__VITE_ASSET__N0G_34WF__"